import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { get } from 'lodash'
import { FormattedDate } from 'react-intl'
import { Modal } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { TasksAwardLeaderNote } from 'components/sections/tasks'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'

export default class TasksSectionsTableSingle extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    validationData: PropTypes.object.isRequired
  }

  state = {
    activityIdSignoff: null,
    activityIdReturn: null,
    activityState: null,
    noteActionId: null
  }

  key = uuid.v1()

  handleApproveModal = data => {
    const activityIdSignoff = get(data, 'id')
    const activityState = get(data, 'activityState.value')

    this.setState(
      {
        activityIdSignoff,
        activityState
      },
      () => {
        this.props.modal(`modal-signoff-activity-${this.key}`)
      }
    )
  }

  handleReturnModal = activityIdReturn => {
    this.setState(
      {
        activityIdReturn
      },
      () => {
        this.props.modal(`modal-return-activity-${this.key}`)
      }
    )
  }

  handleShowNote = noteActionId => {
    this.setState(
      {
        noteActionId
      },
      () => {
        this.props.modal(`modal-show-note-${this.key}`)
      }
    )
  }

  render() {
    const { data, approveModal, returnModal, validationData } = this.props

    return (
      <div>
        <Table ths={tasksLayout.sectionsApprovalSingleTableHeaders}>
          <Data>
            <tr>
              <td>
                {(get(data, 'completionDate') && (
                  <FormattedDate value={data.completionDate} />
                )) ||
                  '---'}
              </td>
              <td className="text--right">
                <ButtonGroup right>
                  <Button
                    type="button"
                    onClick={() => this.handleApproveModal(data)}
                    intlKey="button.approve"
                    small
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    onClick={() => this.handleReturnModal(get(data, 'id'))}
                    intlKey="button.revise"
                    small
                    secondary
                  >
                    Revise
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <Modal
          id={`modal-show-note-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <TasksAwardLeaderNote actionId={this.state.noteActionId} />
        </Modal>
        <Modal id={`modal-signoff-activity-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.activityIdSignoff}
            activityState={this.state.activityState}
            modal={this.props.modal}
            validationData={validationData}
          />
        </Modal>
        <Modal id={`modal-return-activity-${this.key}`} customActions>
          <TaskReturn
            returnTask={returnModal}
            id={this.state.activityIdReturn}

            modal={this.props.modal}
          />
        </Modal>
      </div>
    )
  }
}
